<script setup lang="ts">
import ChqMenuGroup from "../../components/menu/ChqMenuGroup.vue";
import ChqMenuItem from '../../components/menu/ChqMenuItem.vue';
import { appVm } from "../../main-store";

Object.assign(appVm.sidebarState, {
    accounting: {
        public: false,
        volume: false,
        reports: false
    }
});
</script>
<template>
    <h5>
        Accounting
    </h5>
    <ul role="list" class="space-y-1">
        <ChqMenuItem menu-item="/accounting/donations"><i class="fas fa-hand-holding-usd"></i> Take Donation
        </ChqMenuItem>
        <ChqMenuGroup :menu-group="appVm.sidebarState.accounting.public" icon="fa-user" name="Public Clients">
            <ChqMenuItem menu-item="/accounting/public-clients">Apply Payment</ChqMenuItem>
            <ChqMenuItem menu-item="/accounting/credit-balances">Credit Balances</ChqMenuItem>
            <ChqMenuItem menu-item="/checkout/paperwork">Receipts</ChqMenuItem>
        </ChqMenuGroup>
        <ChqMenuGroup :menu-group="appVm.sidebarState.accounting.volume" icon="fa-building" name="Volume Clients">
            <ChqMenuItem menu-item="/accounting/bill">Bill</ChqMenuItem>
            <ChqMenuItem menu-item="/accounting/volume-apply-payment">Apply Payment</ChqMenuItem>
            <ChqMenuItem menu-item="/accounting/invoices">Invoices</ChqMenuItem>
            <ChqMenuItem menu-item="/accounting/volume-summary">Summary</ChqMenuItem>
            <ChqMenuItem menu-item="/accounting/volume-payment-history">VC History</ChqMenuItem>
            <ChqMenuItem menu-item="/accounting/volume-invoice-history">Invoice History</ChqMenuItem>
            <ChqMenuItem menu-item="/accounting/accounts-receivable">Accounts Receivable for VCs</ChqMenuItem>
        </ChqMenuGroup>
        <ChqMenuItem menu-item="/accounting/item-sales"><i class="fas fa-shopping-basket"></i> Item Sales</ChqMenuItem>

        <ChqMenuItem menu-item="/accounting/tools"><i class="fas fa-tools"></i> Tools</ChqMenuItem>

        <ChqMenuGroup :menu-group="appVm.sidebarState.accounting.reports" icon="fa-chart-pie" name="Reports">
            <ChqMenuItem menu-item="/accounting/reconciliation">Reconciliation</ChqMenuItem>
            <ChqMenuItem menu-item="/accounting/financial-export">Financial Export</ChqMenuItem>
            <ChqMenuItem menu-item="/accounting/voided-payments-log">Deleted Payments Log</ChqMenuItem>
        </ChqMenuGroup>
    </ul>
</template>